module.exports = __webpack_public_path__ + "media/usp-recipes-05f70188.svg";